import {RegisterType} from '../component-registry';
import {GuidedUiQuickLinkSection} from '../../models/Guided.schema';
import {GuidedQuickLinkDetails, type GuidedV2Link} from '../../models/quick-link';
import {mapGuidedV2ItemsToGuidedV2ResultList} from '../mappers';
import {GuidedV2ResultListSection} from './result-list';
import {h} from '@stencil/core';
import type {GuidedV2FactoryState} from '../../models/ui';

export class GuidedV2ResultListFactory {
  @RegisterType(GuidedUiQuickLinkSection.type)
  render<T extends GuidedQuickLinkDetails>(inputData: GuidedUiQuickLinkSection, state: GuidedV2FactoryState<T>) {
      const {
        itemSources,
        importance,
        slots,
      } = inputData; //comes from configuration


      const {
        labelProvider,
        results, //the API response
        searchTerm,
        highlightedIndex,
        eventEmitters,
        strategyLinkRenderer,
        badgeHighlightThreshold,
        markupHighlightThreshold,
        unifiedCheckout,
      } = state;

      const name = labelProvider(`guided-v2.quicklink-section.name.${inputData?.name?.toLowerCase()}`,inputData.name);

      const links: GuidedV2Link<GuidedQuickLinkDetails>[] = mapGuidedV2ItemsToGuidedV2ResultList(
        results,
        itemSources,
        labelProvider,
        slots,
        searchTerm,
        badgeHighlightThreshold,
        markupHighlightThreshold,
        unifiedCheckout,
      );


      const clickTarget = inputData.clickTarget
        ?.replace('$TERM',encodeURIComponent(searchTerm))
    ;

      //TODO: limit items to number of slots
      //TODO: insert client side highlighting for badges
      //TODO: insert UI keyboard nav highlighting

      return <GuidedV2ResultListSection
        resultGroupName={name}
        resultGroupOpenUrl={clickTarget}
        links={links}
        strategyLinkRenderer={strategyLinkRenderer}
        highlightedIndex={highlightedIndex}
        eventEmitters={eventEmitters}
        labelProvider={labelProvider}
        unifiedCheckout={unifiedCheckout}
      ></GuidedV2ResultListSection>;
  };
}
